import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import {
  Table,
  Button,
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Row,
  Col,
} from "reactstrap";
import { COINNIK_MARKET_URL_BASE_TOKENS } from "configs/constants";
import "assets/styles/components/table.scss";
import "assets/styles/components/variantProperty.scss";

function MaeketPriceTable({
  columns,
  data,
  tomanLength,
  tetherLength,
  searchInput,
}: any) {
  const { t }: { t: any } = useTranslation();
  const defaultPageSize = 8;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns,
      data,

      initialState: {
        pageSize:
          tomanLength || tetherLength
            ? tomanLength || tetherLength
            : defaultPageSize,
      },
      filters: [
        {
          id: "leaveRequestStatus",
          value: "Pending",
        },
      ],
    },
    useGlobalFilter,
    usePagination
  );
  React.useEffect(() => {
    setGlobalFilter(searchInput);
  }, [searchInput]);

  let symbol = "";
  let pairName = "";
  return (
    <>
      <div className="table-style table position-relative">
        <Table borderless hover responsive {...getTableProps}>
          <thead className=" text-secondary-three-light table-font-mobile ">
            {headerGroups.map((headerGroup) => (
              <tr
                className="tr-border-bottom "
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column: any) => (
                  <th
                    className="py-4 fw-normal  "
                    {...column.getHeaderProps({
                      style: { minWidth: column.minWidth, width: column.width },
                      className: column.collapse ? "collapse" : "",
                    })}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="">
            {page.map((row: any, i: any) => {
              prepareRow(row);
              return (
                <tr
                  className="tr-border-bottom align-middle "
                  {...row.getRowProps()}
                >
                  {row.cells.map((cell: any) => {
                    symbol = cell.row.original.symbol;
                    pairName =
                      cell.row.original.pair === undefined
                        ? "TMN"
                        : cell.row.original.pair.split("/")[1];

                    return (
                      <>
                        <td
                          className="fw-medium none-padding text-center secondary-seven-light "
                          {...cell.getCellProps({
                            style: {
                              minWidth: cell.column.minWidth,
                              width: cell.column.width,
                            },
                            className: cell.column.collapse ? "collapse" : "",
                          })}
                        >
                          {cell.render("Cell")}
                        </td>
                      </>
                    );
                  })}
                  <td className="align-middle d-flex align-items-center justify-content-end">
                    <a
                      href={`${COINNIK_MARKET_URL_BASE_TOKENS}${symbol}_${
                        pairName != undefined ? pairName : "TMN"
                      }`}
                    >
                      <Button size="sm" color="warning">
                        {t("BuyAndSell")}
                      </Button>
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
}
export default MaeketPriceTable;
